var $5968758298d1c6b9$exports = {};
$5968758298d1c6b9$exports = {
    "loading": `\u{B85C}\u{B4DC} \u{C911}\u{2026}`,
    "placeholder": `\u{C120}\u{D0DD}\u{2026}`
};


export {$5968758298d1c6b9$exports as default};
//# sourceMappingURL=ko-KR.mjs.map
